import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import classes from '../appForm/style.module.css'
import Navbar from '../../navbar';
import Header from '../../header';
import { fetchApplication, saveRenewalApplication, safePdf, isThunkFulfilled } from '../../../store/reducers/applicationSlice'
import { getSignature, getAttachments } from '../../../store/reducers/fileSlice';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage, prepareHtmlForPdf } from '../../../utility/utility';
import FormHeader from '../forms/formHeader/formHeader';
import AddAttachment from './attachments';
import FormLoader from '../forms/formLoader';
import { useNavigate } from "react-router-dom";
import { notifyApiError, notifyApiSuccess } from '../../../helpers/apiNotify';
import { saveDataPdfThenStatus, updateApplicationStatus } from '../../../helpers/applicationSaveFlow';
import { createNotification } from '../../../store/reducers/notificationSlice';

const Renewals = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const authToken = user.access_token;
  const params = useParams();
  const application = useSelector((state) => state.applications.application)
  const [pageIds, setPageIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [formIds, setFormIds] = useState([]);
  const [signatureImage, setSignatureImage] = useState('')
  const [inputFields, setInputFields] = useState({});
  const [signatureIds, setSignatureIds] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [imageData, setImageData] = useState('');
  const [showAttachments, setShowAttachments] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (dispatch && params.id && authToken) {
      dispatch(fetchApplication({ id: params.id, accessToken: authToken }));
    }
  }, [dispatch, params.id, authToken])

  useEffect(() => {
    const runAsyncFunctions = async () => {
      if (isLoaded && inputFields && user) {
        await setFormFieldData(application.json_data);
        let userId = user.user.id

        // Use Promise.allSettled to handle both API calls gracefully
        const [signatureResult, attachmentsResult] = await Promise.allSettled([
          getSignature({ userId: userId, applicationId: params.id, authToken }),
          getAttachments({ userId: userId, applicationId: params.id, authToken })
        ]);

        // Handle signature result
        if (signatureResult.status === 'fulfilled' && signatureResult.value) {
          setSignatureImage(signatureResult.value);
        } else {
          const error = signatureResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
        }

        // Handle attachments result
        if (attachmentsResult.status === 'fulfilled' && attachmentsResult.value) {
          const files = attachmentsResult.value.map(filename => ({ name: filename }));
          setUploadedFiles(files);
        } else {
          const error = attachmentsResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
          setUploadedFiles([]);
        }
      }
    };

    runAsyncFunctions();
  }, [isLoaded, user]);

  useEffect(() => {
    if (dispatch && params.id && authToken) {
      dispatch(fetchApplication({ id: params.id, accessToken: authToken }));
    }
  }, [dispatch, params.id, authToken])

  useEffect(() => {
    if (application?.json_data && isLoaded) {
      let jsonFields = {};
      try {
        if (
          typeof application.json_data === "string" &&
          application.json_data.trim().startsWith("{")
        ) {
          jsonFields = JSON.parse(application.json_data);
        } else if (
          typeof application.json_data === "object" &&
          application.json_data !== null
        ) {
          jsonFields = application.json_data;
        } else {
          // Handle cases like [object Object]
          jsonFields = {};
        }
      } catch (e) {
        // Fallback if parsing fails
        console.error('Error parsing json_data:', e);
        jsonFields = {};
      }
      setInputFields(jsonFields);
    }
  }, [application, isLoaded])
  useEffect(() => {
    if (signatureImage != '' && signatureIds.length > 0) {
      signatureIds.forEach(id => {
        const imageInput = document.getElementById(id);
        if (imageInput && imageInput.type === 'image') {
          // Directly set the src of the image input
          let originalWidth = window.getComputedStyle(imageInput).width.replace("px", "")
          let originalTop = window.getComputedStyle(imageInput).top.replace("px", "")
          let height = (originalWidth * 114) / 179;
          imageInput.style.height = height + "px";
          imageInput.style.top = (originalTop - height) + 20 + "px";
          imageInput.src = signatureImage;
          setImageData(signatureImage);
        }
      });
    }
  }, [signatureImage])

  useEffect(() => {
    if (pageIds) {
      hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
    }
  }, [pageIds])

  useEffect(() => {
    if (formIds.length > 0) {
      attachEventHandlers();
    }
  }, [formIds.length]);

  const attachEventHandlers = () => {
    let tempSignatureIds = []

    formIds.forEach(id => {
      const inputField = document.getElementById(id);
      if (inputField.type === 'image') {
        tempSignatureIds.push(id);

      } else if (inputField.type === 'checkbox') {
        inputField.addEventListener('change', handleCheckBoxChange)
      } else {
        inputField.addEventListener('change', handleInputChange);
      }
    });
    setSignatureIds(tempSignatureIds);
  };
  const handleInputChange = (event) => {
    const { id, value } = event.target;

    setInputFields(prevInputFields => ({
      ...prevInputFields,
      [id]: value,
    }));
  };
  const handleCheckBoxChange = (event) => {
    const { id, checked, value } = event.target;

    setInputFields(prevInputFields => {
      // If the checkbox is checked, add it to inputFields
      if (checked) {
        return {
          ...prevInputFields,
          [id]: value,
        };
      } else {
        // If the checkbox is unchecked, remove it from inputFields
        const { [id]: removedValue, ...remainingFields } = prevInputFields;
        return remainingFields;
      }
    })
  };
  const previousPage = () => {
    if (currentPage == pageIds.length + 1) {
      setShowAttachments(false);
      showDiv(currentPage - 1);
      setCurrentPage(currentPage - 1)
    } else {
      if (currentPage - 1 >= 1) {
        hideDiv(currentPage);
        showDiv(currentPage - 1);
        setCurrentPage(currentPage - 1);
      }
    }
  }
  const nextPage = () => {
    if (currentPage + 1 <= pageIds.length) {
      hideDiv(currentPage);
      showDiv(currentPage + 1);
      setCurrentPage(currentPage + 1);
    } else if (currentPage + 1 <= pageIds.length + 1) {
      hideDiv(currentPage);
      setCurrentPage(currentPage + 1);
      setShowAttachments(true);
    }
  }
  const hideDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "none";
  }
  const showDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "";
  }
  const handleSubmitWithLoading = async (e) => {
    const htmlForm = document.getElementById("DocumentPDF")?.outerHTML;
    const preparedHtml = prepareHtmlForPdf(htmlForm, inputFields, pageIds);
    const pdfUser = { id: application.userId || application.user_id || user.user.id };
    const finalState =
      user.user?.user_role === 'company_admin'
        ? 'in_process'
        : 'application_submitted_by_company_user_to_company';
    const isDraft = application?.state === 'draft' || application?.state === 'drafts';

    try {
      let applicationId;

      if (isDraft) {
        const result = await saveDataPdfThenStatus(dispatch, {
          id: params.id,
          token: authToken,
          userId: user.user.id,
          json_data: inputFields,
          files: uploadedFiles,
          form: application.name,
          currentState: application?.state,
          nextState: finalState,
          htmlForm: preparedHtml,
          pdfUser,
          successMessage: 'Application submitted successfully!',
        });
        if (!result.ok) return;
        applicationId = params.id;
      } else {
        // Create renewal as drafts → PDF → status
        const renewalResponse = await saveRenewalApplication({
          token: authToken,
          id: params.id,
          json_data: inputFields,
          state: 'drafts',
          userId: user.user.id,
          files: uploadedFiles,
          form: application.name,
        });

        if (!renewalResponse) {
          notifyApiError(null, 'Failed to submit application. Please try again.');
          return;
        }

        applicationId =
          renewalResponse?.id ||
          renewalResponse?.applicationId ||
          renewalResponse?.application_id ||
          params.id;

        const pdfRes = await dispatch(safePdf({
          htmlForm: preparedHtml,
          user: pdfUser,
          id: applicationId,
          token: authToken,
          silent: true,
        }));
        if (!isThunkFulfilled(pdfRes)) {
          notifyApiError(pdfRes.payload, 'Failed to save PDF');
          return;
        }

        const statusResult = await updateApplicationStatus(dispatch, {
          id: applicationId,
          token: authToken,
          userId: user.user.id,
          json_data: inputFields,
          form: application.name,
          nextState: finalState,
        });
        if (!statusResult.ok) return;

        notifyApiSuccess('Application submitted successfully!');
      }

      if (user.user?.user_role === 'employee') {
        await dispatch(createNotification({
          user_id: user.user.id,
          applicationId,
          applicationName: application.name,
          status: 'submitted',
          accessToken: authToken,
          sendToCompanyAdmins: true,
          companyName: user.user?.company_name,
          employeeName: user.user?.full_name
        }));
      } else {
        await dispatch(createNotification({
          user_id: user.user.id,
          applicationId,
          applicationName: application.name,
          status: 'company_submitted',
          accessToken: authToken,
          sendToCompanyAdmins: true,
          sendToGamingBoardAdmins: true,
          sendToGamingBoardReviewers: true,
          sendToGamingBoardViewers: true,
          companyName: user.user?.company_name,
          employeeName: user.user?.full_name
        }));
      }

      if (user.user?.user_role === 'company_admin') {
        navigate('/in-process-applications');
      } else {
        navigate('/in-review');
      }
    } catch (error) {
      console.error('Error submitting renewal application:', error);
      notifyApiError(error, 'Failed to submit application. Please try again.');
    }
  };

  const saveToDrafts = async (e) => {
    const htmlForm = document.getElementById("DocumentPDF")?.outerHTML;
    const preparedHtml = prepareHtmlForPdf(htmlForm, inputFields, pageIds);
    const pdfUser = { id: application.userId || application.user_id || user.user.id };
    const draftState = typeof e === 'string' && e ? e : 'drafts';
    const isDraft = application?.state === 'draft' || application?.state === 'drafts';

    try {
      if (isDraft) {
        await saveDataPdfThenStatus(dispatch, {
          id: params.id,
          token: authToken,
          userId: user.user.id,
          json_data: inputFields,
          files: uploadedFiles,
          form: application.name,
          currentState: application?.state,
          nextState: draftState,
          htmlForm: preparedHtml,
          pdfUser,
          successMessage: 'Application saved to drafts successfully!',
        });
        return;
      }

      const renewalResponse = await saveRenewalApplication({
        token: authToken,
        id: params.id,
        json_data: inputFields,
        state: draftState,
        userId: user.user.id,
        files: uploadedFiles,
        form: application.name,
      });

      if (!renewalResponse) {
        notifyApiError(null, 'Failed to save draft. Please try again.');
        return;
      }

      const applicationId =
        renewalResponse?.id ||
        renewalResponse?.applicationId ||
        renewalResponse?.application_id ||
        renewalResponse?.newApplicationId ||
        params.id;

      const pdfRes = await dispatch(safePdf({
        htmlForm: preparedHtml,
        user: pdfUser,
        id: applicationId,
        token: authToken,
        silent: true,
      }));
      if (!isThunkFulfilled(pdfRes)) {
        notifyApiError(pdfRes.payload, 'Failed to save PDF');
        return;
      }

      notifyApiSuccess('Application saved to drafts successfully!');
    } catch (error) {
      console.error('Error saving draft renewal application:', error);
      notifyApiError(error, 'Failed to save draft. Please try again.');
    }
  }
  const handlePageChange = (number) => {
    if (number > 0 && number <= pageIds.length + 1) {
      if (number == pageIds.length + 1) {
        hideDiv(currentPage);
        setCurrentPage(number);
        setShowAttachments(true);
      } else {
        if (currentPage == pageIds.length + 1) {
          setShowAttachments(false)
          showDiv(number)
          setCurrentPage(number)
        } else {
          hideDiv(currentPage);
          showDiv(number);
          setCurrentPage(number);
        }
      }
    }
  }
  return (
    <div>
      <Navbar />
      <Header />
      <div className='wrapper'>
        <div className='boxAppBoard boxWhite'>
          <div className="stickyFormHeader">
            <FormHeader applicationName={application.name} nextPage={nextPage} previousPage={previousPage}
              currentPage={currentPage} totalPages={pageIds.length + 1} handleSubmitWithLoading={handleSubmitWithLoading}
              saveToDrafts={saveToDrafts} handlePageChange={handlePageChange} />
          </div>

          <div className={classes['board-content']}>
            {application && <FormLoader applicationName={application.name} setFormIds={setFormIds} setPageIds={setPageIds} setIsLoaded={setIsLoaded} />}

          </div>

          {showAttachments && <AddAttachment signatureIds={signatureIds} setUploadedFiles={setUploadedFiles} uploadedFiles={uploadedFiles} />}
        </div>
      </div>
    </div>
  )
}
export default Renewals